"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureAccessService = void 0;
class FeatureAccessService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Featureaccess({ featureKey, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/featureaccess/{featureKey}',
            path: {
                featureKey: featureKey,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1Featureaccess1({ featureKey, personalKey, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/featureaccess/{featureKey}/{personalKey}',
            path: {
                featureKey: featureKey,
                personalKey: personalKey,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.FeatureAccessService = FeatureAccessService;
